import client from '../httpClient';

// 【listAd001】流入キーワード
// http://10.22.2.48:8080/docs/#/members/get-members-keywords
const listAdGetKeywordsApi = async (params) => {
  try {
    const res = await client.get('/members/keywords', { params });
    return res.data;
  } catch (e) {
    console.error(e);
    return {
      total: 0,
      keywords: [],
    };
  }
};

export default listAdGetKeywordsApi;
